import React, { useState } from "react";
import { FormSpy, Field } from "react-final-form";
import { Card, CardContent, CardHeader, Grid } from "@mui/material";
import AddressLine from "./AddressLineComponent";
import PostalCode from "./PostalCodeComponent";
import SelectComponent from "../Helpers/UserComponents/SelectComponent"; 
import { MenuItemsForDropDown } from "@soqs/common";
import { useSelector } from "react-redux";
import { dropdownoptions, dropdownsloading } from "../../features/trnAppSlice";
import SwitchAdapter from "../Adapters/SwitchAdapter";

const PostalAddressComponent = () => {
  const dropdownopts = useSelector(dropdownoptions);
  const dropdownoptsloading = useSelector(dropdownsloading); 
  const [
    isPostalAddressSameAsResidential,
    setIsPostalAddressSameAsResidential,
  ] = useState(true);
  const [hideAddress] = useState(true);

  return (
    <Grid>
      <Card>
        <div style={{ display: "flex", alignItems: "center" }}>
          <CardHeader
            title="My Postal Address Details:"
            style={{ display: "flex", alignItems: "center" }}
          />
          <Grid size={{ xs: 6 ,md: 2}}>
            <Field
              name="pitRegPostalAddressSameAsResidential"
              component={SwitchAdapter}
              type="checkbox"
              label={"Same as Residential"}
              initialValue={false}
            />
          </Grid>
        </div>
        <>
          <CardContent>
            {isPostalAddressSameAsResidential === true ? (
              hideAddress
            ) : (
              <Grid container columnSpacing={1.5} rowSpacing={0.5}>
                <Grid size={{ xs: 12 ,md: 6}}>
                  <AddressLine
                    name="pitRegPostalAddressBoxNumber"
                    label="Postal Box Number"
                    maxLengths="8"
                    required={true}
                  />
                </Grid>

                <Grid size={{ xs: 12 ,md: 6}}>
                  <AddressLine
                    name="pitRegPostalAddressSuburb"
                    label="Suburb"
                    required={true}
                    maxLengths="27"
                  />
                </Grid>

                <Grid size={{ xs: 12 ,md: 6}}>
                  <AddressLine
                    name="pitRegPostalAddressCity"
                    label="City"
                    maxLengths="27"
                    required={true}
                  />
                </Grid>

                <Grid size={{ xs: 12 ,md: 6}}>
                  <SelectComponent
                    name="pitRegPostalAddressCountry"
                    label="Country"
                    options={MenuItemsForDropDown(
                      "country",
                      dropdownopts,
                      false
                    )}
                    optionsloading={dropdownoptsloading}
                    defaultValue={"ZA"}
                    required={true}
                  />
                </Grid>

                <Grid size={{ xs: 6 ,md: 2}}>
                  <PostalCode required={true} maxLengths="4" />
                </Grid>
              </Grid>
            )}
          </CardContent>
        </>
        <FormSpy
          subscription={{ values: true }}
          onChange={({ values }) => {
            setIsPostalAddressSameAsResidential(
              values.pitRegPostalAddressSameAsResidential
            );
          }}
        />
      </Card>
    </Grid>
  );
};

export default PostalAddressComponent;
